// Root class of the rendered <PickyDateTime/> popup.
const PICKER_ROOT_SELECTOR = '.picky-date-time';

// True when a click happened anywhere inside the open date picker.
//
// The outside-click handlers used to compare `e.target.className` against a
// hard coded list of class names. The month/year arrows, the month/year
// selector panel and the day cells all sit on elements whose class names were
// not in that list, so clicking them closed the picker before their own
// onClick could take effect - only days of the already visible month could be
// picked. Walking up to the picker root covers every element it renders.
export const isDatePickerClick = (target) => {
    const node = target && target.nodeType === Node.TEXT_NODE ? target.parentElement : target;
    return !!(node && node.closest && node.closest(PICKER_ROOT_SELECTOR));
};
